<script setup lang="ts">
const { t } = useTexts();
const { isMobile } = useLayout();
const { openSupportChat, hasLiveSupport } = useLiveSupport();
const { linkToHelpCenter } = useLinks();
const { companyPhone } = useCompanyData();

const phoneNumber = computed(() => {
  return companyPhone.value;
});

useSeo({
  title: t('contact.title'),
});
</script>

<template>
  <ClientOnly>
    <div class="pageContainer">
      <UserPageAccountTitle
        v-if="isMobile"
        :back-function="() => $router.back()"
        :title="$t('contact.title')"
      />

      <div
        v-else
        :class="$style.pageTitle"
      >
        <span :class="$style.itemText">{{ $t('contact.title') }}</span>
      </div>

      <section :class="$style.contactContent">
        <article
          v-if="hasLiveSupport"
          :class="$style.contactItem"
        >
          <h2 :class="$style.contactTitle">
            <NuxtIcon
              :class="$style.buttonIcon"
              name="chat"
            />
            {{ $t('contact.chat.title') }}
          </h2>
          <p :class="$style.contactDesc">
            {{ $t('contact.chat.desc') }}
          </p>
          <button
            :class="$style.contactLink"
            @click="openSupportChat"
          >
            {{ $t('contact.chat.link') }}
          </button>
        </article>

        <article
          v-if="linkToHelpCenter"
          :class="$style.contactItem"
        >
          <h2 :class="$style.contactTitle">
            <NuxtIcon
              :class="$style.buttonIcon"
              name="help"
            />
            {{ $t('contact.help.title') }}
          </h2>
          <p :class="$style.contactDesc">
            {{ $t('contact.help.desc') }}
          </p>
          <a
            :class="$style.contactLink"
            :href="linkToHelpCenter"
            target="_blank"
          >
            {{ $t('contact.help.link') }}
          </a>
        </article>

        <article
          v-if="phoneNumber"
          :class="$style.contactItem"
        >
          <h2 :class="$style.contactTitle">
            <NuxtIcon
              :class="$style.buttonIcon"
              name="phone"
            />
            {{ $t('contact.phone.title') }}
          </h2>
          <p :class="$style.contactDesc">
            {{ $t('contact.phone.desc') }}
          </p>
          <a
            :class="$style.contactLink"
            :href="`tel:${phoneNumber}`"
          >
            {{ phoneNumber }}
          </a>
        </article>

        <h1 class="text-white/60 text-center mb-4 px-4 leading-tight">
          Canais de Atendimento: suporte ao cliente e contatos oficiais
        </h1>
      </section>
    </div>
  </ClientOnly>
</template>

<style module lang="scss">
.pageTitle {
  @apply w-full py-4 px-4 flex items-center justify-between gap-3 text-texts/90;

  .itemText {
    @apply text-lg mr-auto font-bold lg:text-2xl;
  }
}

.contactContent {
  @apply px-5 py-5;

  .contactItem {
    @apply mb-8 text-texts;

    .contactTitle {
      @apply font-bold pb-3 border-b border-texts/40 border-solid flex items-center justify-start gap-2;

      .buttonIcon {
        @apply text-2xl text-primary;
      }
    }

    .contactDesc {
      @apply text-xs text-texts/80 mb-3 mt-2;
    }

    .contactLink {
      @apply text-primary text-xs underline;
    }
  }
}
</style>
